import { jsx, jsxs } from "react/jsx-runtime";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  __css,
  tokens
} from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
const useStyles = __css({"reason":{"Bhrd7zp":"fl43uef","Bo78w4l":"f7bpaku"},"description":{"sj55zd":"fkfq4zb"}});
function StepUpDialog({ open, onOpenChange, reason, onContinue }) {
  const { t } = useTranslation("ui");
  const styles = useStyles();
  return /* @__PURE__ */ jsx(
    Dialog,
    {
      open,
      modalType: "alert",
      onOpenChange: (_event, data) => {
        onOpenChange(data.open);
      },
      children: /* @__PURE__ */ jsx(DialogSurface, { children: /* @__PURE__ */ jsxs(DialogBody, { children: [
        /* @__PURE__ */ jsx(DialogTitle, { children: t("components.stepUpDialog.title") }),
        /* @__PURE__ */ jsxs(DialogContent, { children: [
          /* @__PURE__ */ jsx("p", { className: styles.reason, children: reason }),
          /* @__PURE__ */ jsx("p", { className: styles.description, children: t("components.stepUpDialog.description") })
        ] }),
        /* @__PURE__ */ jsxs(DialogActions, { children: [
          /* @__PURE__ */ jsx(
            Button,
            {
              appearance: "secondary",
              onClick: () => {
                onOpenChange(false);
              },
              children: t("components.stepUpDialog.cancel")
            }
          ),
          /* @__PURE__ */ jsx(Button, { appearance: "primary", onClick: onContinue, children: t("components.stepUpDialog.continue") })
        ] })
      ] }) })
    }
  );
}
export {
  StepUpDialog
};
//# sourceMappingURL=step-up-dialog.js.map

import "/opt/batiflow/app/packages/ui/dist/components/step-up-dialog/step-up-dialog.griffel.css";